import { LOGIN_HEADER_KEY } from '../../../APIConstants';
import { awExternalPicklistApi } from '../Base';
import { UserInfo } from '../models';
import { FirmList, GroupList } from '../models/ExternalPickList';

export const firmListPath = 'api/v1/aperio/firms';
export const groupListPath = `${firmListPath}/`;

// @DEPRECATED : To be removed when outbound migration is complete in production env.
async function fetchList<T>(path: string, userInfo: UserInfo): Promise<T> {
  try {
    const response = await awExternalPicklistApi.get(path, {
      headers: {
        [LOGIN_HEADER_KEY]: userInfo.login,
      },
    });
    return response?.data as T;
  } catch (error) {
    return {} as T;
  }
}

// @DEPRECATED : To be removed when outbound migration is complete in production env.
export function getFirmList(userInfo: UserInfo): Promise<FirmList> {
  return fetchList<FirmList>(firmListPath, userInfo);
}

// @DEPRECATED : To be removed when outbound migration is complete in production env.
export function getGroupList(firmId: string, userInfo: UserInfo): Promise<GroupList> {
  return fetchList<GroupList>(`${firmListPath}/${firmId}`, userInfo);
}
